// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-sector-criteria {
  display: inline-block;

  width: 100%;
  position: relative;

  text-align: left;
}

.screener-sector-criteria-button {
  display: inline-flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  border: none;
  padding: 9px 12px 9px 16px;
  background-color: transparent;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;

  &.open {
    background-color: var(--color-brand);
  }
}

.screener-sector-criteria--header {
  width: 100%;
}

.screener-sector-criteria--header .screener-sector-criteria-button {
  box-sizing: border-box;
  height: 40px;
  border: 1px solid var(--input-border);
  border-radius: 4px;
  background-color: var(--surface-primary);
  padding: 6px 16px;
  cursor: pointer;
  gap: 8px;

  &:hover {
    border: 1px solid var(--border-primary-brand);
  }
}

.screener-sector-criteria--header .screener-sector-criteria-label {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--input-text);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;

  &.open {
    color: var(--input-text);
  }
}

.screener-sector-criteria--header .screener-sector-criteria-expand {
  flex-shrink: 0;
  width: 16px;
  height: 16px;

  path {
    fill: var(--text-instrument);
  }

  &.open {
    transform: rotate(180deg);

    path {
      fill: var(--text-instrument);
    }
  }
}

.screener-sector-criteria-button-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.screener-sector-criteria-label {
  font-size: 12px;
  line-height: 100%;
  font-weight: 400;
  color: #000000;

  &.open {
    color: #ffffff;
  }
}

.screener-sector-criteria-count {
  box-sizing: border-box;
  padding: 0px 4px;
  min-height: 16px;

  border-radius: 20px;
  background-color: #000000;
  color: #ffffff;

  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  text-align: center;
  align-content: center;

  &.open {
    background-color: #ffffff;
    color: #121212;
  }
}

.screener-sector-criteria-expand {
  path {
    fill: #1e1f2f;
  }

  &.open {
    transform: rotate(180deg);

    path {
      fill: #bdbdbd;
    }
  }
}

.screener-sector-criteria-list {
  box-sizing: border-box;
  transform-origin: top right;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  margin-top: 4px;
  border-radius: 4px;
  padding: 8px 1px 16px 1px;
  width: 100%;

  border: 1px solid #bdbdbd;
  box-shadow: 0px 4px 8px 0px #0000001a;

  background-color: #fff;
  outline: none;
  overflow: hidden;
}

.screener-sector-criteria-options {
  display: flex;
  flex-direction: column;
}

.screener-sector-criteria-option-item-container {
  box-sizing: border-box;
  height: 48px;

  padding: 12px 16px;

  cursor: pointer;
  transition-property:
    color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-duration: 150ms;

  &:hover {
    background-color: var(--color-brand-hover2);
  }
}

.screener-sector-criteria-option-item-toggle-button {
  display: flex;
  align-items: center;
  gap: 8px;

  width: 100%;
  height: 100%;
}

.screener-sector-criteria-option-item-toggle-button-checkbox {
  height: 100%;
}

.screener-sector-criteria-option-item-toggle-button-checkbox svg {
  width: 24px;
  height: 24px;
  color: var(--color-brand);
}

.screener-sector-criteria-option-item-toggle-button-checkbox.checked
  svg
  path:first-child {
  fill: var(--color-brand);
}

.screener-sector-criteria-option-item-toggle-button-label {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/SectorCriteria/SectorCriteria.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;;EAErB,WAAW;EACX,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;;EAEnB,WAAW;EACX,YAAY;;EAEZ,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;;EAE7B,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;;EAE1B;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,eAAe;EACf,QAAQ;;EAER;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;EAEhB;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;;IAEzB;MACE,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;;EAEd;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;;EAEhB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;;EAEd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;;EAErB;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;;IAEzB;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;;EAEX,yBAAyB;EACzB,qCAAqC;;EAErC,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;;EAEZ,kBAAkB;;EAElB,eAAe;EACf;8EAC4E;EAC5E,0BAA0B;;EAE1B;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;AAChB","sourcesContent":[".screener-sector-criteria {\n  display: inline-block;\n\n  width: 100%;\n  position: relative;\n\n  text-align: left;\n}\n\n.screener-sector-criteria-button {\n  display: inline-flex;\n  gap: 8px;\n  justify-content: space-between;\n  align-items: center;\n\n  width: 100%;\n  height: 32px;\n\n  border: none;\n  padding: 9px 12px 9px 16px;\n  background-color: transparent;\n\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n\n  &.open {\n    background-color: var(--color-brand);\n  }\n}\n\n.screener-sector-criteria--header {\n  width: 100%;\n}\n\n.screener-sector-criteria--header .screener-sector-criteria-button {\n  box-sizing: border-box;\n  height: 40px;\n  border: 1px solid var(--input-border);\n  border-radius: 4px;\n  background-color: var(--surface-primary);\n  padding: 6px 16px;\n  cursor: pointer;\n  gap: 8px;\n\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n  }\n}\n\n.screener-sector-criteria--header .screener-sector-criteria-label {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--input-text);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n\n  &.open {\n    color: var(--input-text);\n  }\n}\n\n.screener-sector-criteria--header .screener-sector-criteria-expand {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n\n  path {\n    fill: var(--text-instrument);\n  }\n\n  &.open {\n    transform: rotate(180deg);\n\n    path {\n      fill: var(--text-instrument);\n    }\n  }\n}\n\n.screener-sector-criteria-button-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.screener-sector-criteria-label {\n  font-size: 12px;\n  line-height: 100%;\n  font-weight: 400;\n  color: #000000;\n\n  &.open {\n    color: #ffffff;\n  }\n}\n\n.screener-sector-criteria-count {\n  box-sizing: border-box;\n  padding: 0px 4px;\n  min-height: 16px;\n\n  border-radius: 20px;\n  background-color: #000000;\n  color: #ffffff;\n\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 100%;\n  text-align: center;\n  align-content: center;\n\n  &.open {\n    background-color: #ffffff;\n    color: #121212;\n  }\n}\n\n.screener-sector-criteria-expand {\n  path {\n    fill: #1e1f2f;\n  }\n\n  &.open {\n    transform: rotate(180deg);\n\n    path {\n      fill: #bdbdbd;\n    }\n  }\n}\n\n.screener-sector-criteria-list {\n  box-sizing: border-box;\n  transform-origin: top right;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 10;\n  margin-top: 4px;\n  border-radius: 4px;\n  padding: 8px 1px 16px 1px;\n  width: 100%;\n\n  border: 1px solid #bdbdbd;\n  box-shadow: 0px 4px 8px 0px #0000001a;\n\n  background-color: #fff;\n  outline: none;\n  overflow: hidden;\n}\n\n.screener-sector-criteria-options {\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-sector-criteria-option-item-container {\n  box-sizing: border-box;\n  height: 48px;\n\n  padding: 12px 16px;\n\n  cursor: pointer;\n  transition-property:\n    color, background-color, border-color, text-decoration-color, fill, stroke;\n  transition-duration: 150ms;\n\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n}\n\n.screener-sector-criteria-option-item-toggle-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  width: 100%;\n  height: 100%;\n}\n\n.screener-sector-criteria-option-item-toggle-button-checkbox {\n  height: 100%;\n}\n\n.screener-sector-criteria-option-item-toggle-button-checkbox svg {\n  width: 24px;\n  height: 24px;\n  color: var(--color-brand);\n}\n\n.screener-sector-criteria-option-item-toggle-button-checkbox.checked\n  svg\n  path:first-child {\n  fill: var(--color-brand);\n}\n\n.screener-sector-criteria-option-item-toggle-button-label {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
